import { GisSettingsComponent } from './gis-settings.component'
import { gisRoutes } from './gis-settings.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [GisSettingsComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(gisRoutes, { scrollPositionRestoration: 'top' }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [GisSettingsComponent],
})
export class GisSettingsModule {}
